module.exports = __webpack_public_path__ + "static/OldMansJourney2-737cfc812be13ef88cee05058307ed2e.png";